import { PHONE } from "constants/at-need";
import { formatPhoneNumber } from "helpers/phone";

const CONTACT_PHONE = formatPhoneNumber(PHONE);
const CONTACT_PHONE_HREF = `tel:${PHONE}`;

type CallButtonVariant = "primary" | "outline" | "compact" | "inline";

type CallButtonProps = {
  variant?: CallButtonVariant;
  className?: string;
};

const baseButton =
  "flex items-center justify-center rounded-lg font-bold text-soil text-base px-4";

const variantStyles: Record<CallButtonVariant, string> = {
  primary: `${baseButton} w-full bg-cantelope sm:px-10 py-4`,
  outline: `${baseButton} w-full border-2 border-soil py-4 transition hover:bg-soil/5`,
  compact: `${baseButton} min-h-[44px] bg-cantelope py-2`,
  inline:
    "inline-block rounded-lg bg-cantelope px-8 py-4 font-semibold text-soil transition hover:bg-cantelope/90",
};

/**
 * Call Button component
 * A simple call-to-action button that links to the phone number
 */
export default function CallButton({
  variant = "primary",
  className = "",
}: CallButtonProps) {
  return (
    <a
      href={CONTACT_PHONE_HREF}
      className={`${variantStyles[variant]} ${className}`}
    >
      Call {CONTACT_PHONE}
    </a>
  );
}
